import { Routes } from "@angular/router";
import { PulseReportChartPageComponent } from "./pulse-report-chart-page/pulse-report-chart-page.component";
import { PulseReportPageComponent } from "./pulse-report-page/pulse-report-page.component";
import { authGuard } from "../../../core/guards/auth.guard";

export const pulseReportChartPageRoutes: Routes = [
  {
    path: 'pulse_report_chart',
    component: PulseReportChartPageComponent,
    canActivate: [authGuard]
  },
  {
    path: 'records/pulse-reports',
    component: PulseReportPageComponent,
    canActivate: [authGuard]
  }
]
